import { Close } from "@mui/icons-material";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { useState } from "react";

const FilePreviewField = ({ ...props }) => {
  const { id, title } = props;
  const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(title);
  const [open, setOpen] = useState(false);
  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Typography
          variant="body2"
          sx={{ flexGrow: 1, color: "primary.main", cursor: "pointer" }}
          onClick={() => setOpen(true)}
        >
          {title || "File"}
        </Typography>
      </div>

      {isImage && (
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            {title}
            {/* right close icon */}
            <IconButton
              onClick={() => setOpen(false)}
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ textAlign: "center", p: 4 }}>
            <img
              src={
                `${
                  import.meta.env.VITE_API_URL
                }/requestdata/actions/downloadFile/` + id
              }
              alt={title}
              style={{ maxWidth: "100%", maxHeight: "80vh" }}
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default FilePreviewField;
